import React, { useState, useEffect } from "react";
import { Spin, Empty } from "antd";
import { Column } from "@ant-design/plots";
import { settlementService } from "../../../../api/enhancedApi";

const InvoiceLifecycleWidget = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const fetchStats = async () => {
        setLoading(true);
        try {
            const response = await settlementService.getInvoiceDataSourceStats();
            // response is axios response: {status, data, headers...}
            // response.data is backend return: { RECEIVED: 10, OCR_COMPLETED: 5, ... }
            const chartData = Object.entries(response.data).map(([status, count]) => ({
                status,
                count,
            }));

            // Define a logical order for the lifecycle
            const order = ["RECEIVED", "OCR_IN_PROGRESS", "OCR_COMPLETED", "OCR_FAILED", "STRUCTURE_IN_PROGRESS", "STRUCTURE_COMPLETED", "STRUCTURE_FAILED", "ALLOCATION_IN_PROGRESS", "ALLOCATION_COMPLETED", "ALLOCATION_FAILED", "CONFIRMED", "REJECTED"];

            chartData.sort((a, b) => {
                return order.indexOf(a.status) - order.indexOf(b.status);
            });

            setData(chartData);
        } catch (error) {
            console.error("Failed to fetch invoice stats:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
    }, []);

    const config = {
        data,
        xField: "status",
        yField: "count",
        color: "#70d8bd", // var(--accent-primary)
        label: {
            style: {
                fill: "#e0e0e0", // var(--text-primary)
                opacity: 0.8,
            },
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
                style: {
                    fill: "#a3a3a3", // var(--text-secondary)
                },
            },
        },
        yAxis: {
            label: {
                style: {
                    fill: "#a3a3a3", // var(--text-secondary)
                },
            },
            grid: {
                line: {
                    style: {
                        stroke: "rgba(255, 255, 255, 0.1)", // var(--border-color)
                    },
                },
            },
        },
        tooltip: {
            theme: "dark",
        },
    };

    return (
        <div style={{ height: "100%", minHeight: "300px" }}>
            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <Spin />
                </div>
            ) : data.length > 0 ? (
                <Column {...config} />
            ) : (
                <Empty description="暂无数据" />
            )}
        </div>
    );
};

export default InvoiceLifecycleWidget;
